<script setup>
import { ref } from "vue";
import axios from "axios";
const email = ref("");
const password = ref("");
const ruleEmail = ref([(v) => !!v || "Email is required"]);
const rulePassword = ref([
  (v) => !!v || "password is required",
  (v) => (v && v.length <= 8) || "Name must be less than 8 characters",
]);
const Login = () => {
  if (email.value === "" || password.value === "") {
    alert("Please fill all fields");
  } else {
    axios
      .post("api/login", {
        email: email.value,
        password: password.value,
      })
      .then((res) => {
       
          localStorage.setItem("token", res.data.token);
          alert(res.data.message);
          window.location.href = "/whatsapps";
         
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  }
};
</script>
<template>

<div class="login-container">
    <h2>{{ $t("Login In") }}</h2>
    <!-- <form id="loginForm"> -->
      <input type="email"    v-model="email"  placeholder="email" required />
      <input type="password"  v-model="password" placeholder="password" required />
      <button   @click="Login()" block class="mt-2">{{ $t('Login In') }}</button>
      <br>
        <!-- <router-link to="/forgot-password">
            <button type="submit" block class="m-2 btn btn-warning">{{
              $t("Forgot Password")
            }}</button>
          </router-link> -->
          <!-- <br> -->
          <!-- <router-link to="/register">
            <button type="submit" block class=" m-2 btn btn-success">{{
              $t("Create an Account")
            }}</button>
          </router-link>
   -->
     
    <!-- </form> -->
  </div> 
</template>
<style>
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #f7f7f7;
    }
    .login-container {
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
    input {
      width: 100%;
      padding: 10px;
      margin: 10px 0;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    button {
      padding: 10px 15px;
      background-color: #28a745;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    button:hover {
      background-color: #218838;
    }
  </style>